import React from "react";

export default function IconContainer(props) {
	return (
		<span className={props.className} style={{ display: "inline-flex", ...props.style }}>
			{props.children}
		</span>
	);
}
